import { render } from "./ShortTextComponent.vue?vue&type=template&id=55a8202e&scoped=true"
import script from "./ShortTextComponent.vue?vue&type=script&lang=js"
export * from "./ShortTextComponent.vue?vue&type=script&lang=js"

import "./ShortTextComponent.vue?vue&type=style&index=0&id=55a8202e&scoped=true&lang=css"

import exportComponent from "C:\\_TimetipCode\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a8202e"]])

export default __exports__